import { Divider, Popover, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import TemplateRound from "./TemplateRound";

function MorePopover({ anchorEl, handleClose, items, isOpen }) {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="more-user-popover"
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <MDBox p={2}>
          {items.map((item, index) => (
            <>
              <Stack direction="row" spacing={2} alignItems="center">
                <TemplateRound open={isOpen} color={item.color} title="" />
                <MDTypography>{item.name}</MDTypography>
              </Stack>
              {items.length - 1 !== index && (
                <Divider
                  variant="inset"
                  component="li"
                  sx={{ my: 1, backgroundColor: "#9b9b9b" }}
                />
              )}
            </>
          ))}
        </MDBox>
      </Popover>
    </div>
  );
}

export default MorePopover;
